import AScene from '../../library/ExtendedObjects/AScene.js';
import TransitionBushes from '../intro/TransitionBushes.js';
import gameData from '../../gameData.js';
import Game_UI from './Game_UI.js';
import Game_Snake from './Game_Snake.js';
import Game_Feedback from './Game_Feedback.js';
import Game_UnlockedPopup from './Game_UnlockedPopup.js';
import Game_Menu from './Game_Menu.js';
import Game_Instructions from './Game_Instructions.js';
import ABCyaPhaser, { Audio } from '@abcya/abcya_phaser';
import LocalizationSoundAssetKeys from '../../Localization-SoundAssetKeys.js';
import ABCyaLib from '@abcya/abcya_lib';

export default class Game extends AScene
{
    static get KEY() { return 'Game'; }

    constructor () 
	{
        super("Game");
    }

    create()
    {
        this.background = this.addImage(this.mid.x, this.mid.y, gameData.gameTypes[gameData.curGameType].background);

        this.skipNumberForInstructionsRead = true;
        this.transitionBushes = new TransitionBushes(this);
        this.ui = new Game_UI(this, (numba)=>{this.eh_NumberSubmitted(numba);}, this.eh_SnakeCreated);
        this.add.existing(this.ui);

        this.collide_group = this.matter.world.nextGroup();
        this.noCollide_group = this.matter.world.nextGroup();
        this.collide_cat = this.matter.world.nextCategory();
        this.noCollide_cat = this.matter.world.nextCategory();
        this.matter.add.mouseSpring({ length: 0, stiffness: 0, collisionFilter: { group: this.noCollide_group } });

        this.states = {
            LISTEN: 0,
            READ: 1,
            COUNT: 2,
        };

        this.activeRegion = {
            top: 135,
            bot: 635,
            left: 300,
            right: 990
        };

        this.previousNumbers = [];
        this.snakes = [];
        this.curUnits = 1;

        this.setState(this.states[gameData.curGameType]);

        this.feedback = new Game_Feedback(this);
        this.unlockedPopup = new Game_UnlockedPopup(this).setDepth(5);
        this.addContainer(this.mid.x, this.mid.y, this.unlockedPopup);
        this.instructionsPopup = new Game_Instructions(this).setDepth(5);
        this.addContainer(this.mid.x, this.mid.y, this.instructionsPopup);

        this.menu = new Game_Menu(this).setDepth(5);
        this.addContainer(this.mid.x, this.mid.y, this.menu);

        this.playUnlockedVO = false;

        this.buttonBlocker = this.add.rectangle(0, 0, 350, this.scale.width).setOrigin(0);

        // InputHelper.Listen(InputHelper.KeyCodes.A, ()=>{
        //     this.eh_NumberSubmitted(this.curNumber);
        // });

        this.addDelay(100, ()=>{this.checkCorrectNum();});
    }

    setState(state)
    {
        this.ui.setState(state);
        this.checkCorrectNum();

        if (state == this.states.COUNT) {
            this.checkCurUnits();
            this.nextRound_Count();
            if(ABCyaLib.Environment.instance.gameConfig.subtitle !== null){
              if(!this.skipNumberForInstructionsRead){
                this.ui.title.setNumber(this.curNumber, gameData.gameTypes[gameData.curGameType].curCorrect <= 0 && gameData.gameTypes[gameData.curGameType].stagesComplete <= 0);
              }
              else{
                this.skipNumberForInstructionsRead = false;
              }
            }
        }
        else {
            this.checkCurUnits();
            this.nextRoundRead_Listen();
        }
    }

    nextRound_Count()
    {
        this.getNewNumber();

        let ones = this.curNumber % 10;
        let tens = Math.floor((this.curNumber - ones)%100 / 10);
        let hundreds = Math.floor((this.curNumber - ones - tens) / 100);

        for (let i = 0; i < hundreds; i++)  this.addDelay(i * 100, ()=>{this.createSnake(100, false);});
        for (let i = 0; i < tens; i++)  this.addDelay(i * 100, ()=>{this.createSnake(10, false);});
        if (ABCyaLib.Environment.instance.gameConfig.gameType === 'COUNT' && ones > 1) {
          this.onesCreateSnake(ones, false);
        }
        else {
          for (let i = 0; i < ones; i++)  this.addDelay(i * 100, ()=>{this.createSnake(1, false);});
        }
    }

    nextRoundRead_Listen()
    {
        this.getNewNumber();

        this.ui.snakeMenu.reset();
        this.ui.title.setNumber(this.curNumber, gameData.gameTypes[gameData.curGameType].curCorrect <= 0 && gameData.gameTypes[gameData.curGameType].stagesComplete <= 0);

      //   if (ABCyaLib.Environment.instance.gameConfig.gameType === 'READ'){
      //     if(!this.skipNumberForInstructionsRead) {
      //       this.ui.title.speakNumber();
      //     }
      // }
    }

    getNewNumber()
    {
        if(gameData.units == 1)
        {
            this.curNumber = Math.floor(Math.random() * 9) + 1;
        }
        else if(gameData.units == 10)
        {
            this.curNumber = Math.floor(Math.random() * 89) + 10;
        }
        else
        {
            this.curNumber = Math.floor(Math.random() * 299) + 100;
        }

        if(this.previousNumbers.indexOf(this.curNumber) != -1) this.getNewNumber();
        this.previousNumbers.push(this.curNumber);
        if(this.previousNumbers.length >= 9) this.previousNumbers.shift();
    }

    onesCreateSnake(countNum){
      const snakeCont = this.add.container();
      const depthArray = [];
      let doubleSuffix;
      let testCon;
      let xDarkAdjust;
      let xLightAdjust;
      let tailLight;
      let tailDark;

      const namePrefix = `snakes/Snake${gameData.curSnakeIndex + 1}_`;

      if (gameData.curSnakeIndex === 0 || gameData.curSnakeIndex === 5){
        testCon = (num)=>{return num % 2 === 1};
        xDarkAdjust = 2;
        xLightAdjust = 4;
        tailLight = 3;
        tailDark = 3;
        doubleSuffix = 'Light';
      }
      else {
        testCon = (num)=>{return num % 2 === 0};
        xDarkAdjust = 4;
        xLightAdjust = 2;
        tailLight = 3;
        tailDark = 2;
        doubleSuffix = 'Dark';
      }

      if(countNum === 2){
        snakeCont.tail = ABCyaPhaser.Images.addImage(2, 24, `${namePrefix}Tail${doubleSuffix}`, snakeCont);
        snakeCont.head = ABCyaPhaser.Images.addImage(0, 0, `${namePrefix}Head`, snakeCont);
        snakeCont.bodyArray = [];
      }
      else if (countNum > 2){
        let curY = 25;
        for(let num = 2; num < countNum; num++){
          let suffix = '';
          let xPos = 0;
          if(testCon(num)){
            suffix = 'Dark';
            xPos = xDarkAdjust;
          }
          else{
            suffix = 'Light';
            xPos = xLightAdjust;
          }
          const temp = ABCyaPhaser.Images.addImage(xPos, curY, `${namePrefix}${suffix}`, snakeCont);
          depthArray.push(temp);
          curY += 19;
        }

        let suffix = '';
        let tailX = 0;
        if(testCon(countNum)){
          suffix = 'Dark';
          tailX = tailLight;
        }
        else{
          suffix = 'Light';
          tailX = tailDark;
        }

        const tail = ABCyaPhaser.Images.addImage(tailX, curY, `${namePrefix}Tail${suffix}`, snakeCont);
        const head = ABCyaPhaser.Images.addImage(0, 1, `${namePrefix}Head`, snakeCont);

        for(let i = depthArray.length; i > -1; i--){
          snakeCont.bringToTop(depthArray[i]);
        }
        snakeCont.bringToTop(head);

        snakeCont.head = head;
        snakeCont.tail = tail;
        snakeCont.bodyArray = depthArray;
      }

      snakeCont.setFrame = ()=>{
        const namePrefix = `snakes/Snake${gameData.curSnakeIndex + 1}_`;
        let suffix;

        // if 1 or 5, light then dark otherwise dark then light
        if (gameData.curSnakeIndex === 0 || gameData.curSnakeIndex === 5){
          suffix = ['Light', 'Dark'];
        }
        else{
          suffix = ['Dark', 'Light'];
        }

        snakeCont.head.setFrame(`${namePrefix}Head`);
        snakeCont.bodyArray.forEach((body, index)=>{
          body.setFrame(`${namePrefix}${suffix[index % 2]}`)
        })
        const indexNum = snakeCont.bodyArray.length % 2;
        snakeCont.tail.setFrame(`${namePrefix}Tail${suffix[indexNum]}`)
      }

      let snake = new Game_Snake(this, this.input.x, this.input.y, 10, this.collide_group, this.noCollide_group, this.collide_cat, this.noCollide_cat, snakeCont);
      let ar = this.activeRegion;

      let minX = ar.left + (snake.image.width * .5);
      let maxX = ar.right - (snake.image.width * .5);
      let minY = ar.top + (snake.image.height);
      let maxY = ar.bot - (snake.image.height);

      snake.image.x = Math.random() * (maxX - minX) + minX;
      snake.image.y = Math.random() * (maxY - minY) + minY;
      snake.animateIn();

      snake.setSelected(false);
      this.add.existing(snake);
      this.snakes.push(snake);
      return snakeCont;
    }

    createSnake(unit, lockToMouse)
    {
        let snake = new Game_Snake(this, this.input.x, this.input.y, unit, this.collide_group, this.noCollide_group, this.collide_cat, this.noCollide_cat);
        let ar = this.activeRegion;

        if(!lockToMouse)
        {
            let minX = ar.left + (snake.image.width * .5);
            let maxX = ar.right - (snake.image.width * .5);
            let minY = ar.top + (snake.image.height * .5);
            let maxY = ar.bot - (snake.image.height * .5);

            snake.image.x = Math.random() * (maxX - minX) + minX;
            snake.image.y = Math.random() * (maxY - minY) + minY;
            snake.animateIn();
        }
        else
        {
            snake.setSelected(false);
        }

        this.add.existing(snake);
        this.snakes.push(snake);
    }

    eh_NumberSubmitted(submittion)
    {
        if(this.curNumber == submittion) //CORRECT!
        {
            this.buttonBlocker.setInteractive();

            if(this.ui.numPad) this.ui.numPad.submitButton.setEnabled(false);
            else this.ui.snakeMenu.submitButton.setEnabled(false);
            this.ui.menuButton.setEnabled(false);
            gameData.gameTypes[gameData.curGameType].curCorrect++;

            this.feedback.displayCorrect();
            this.addDelay(2400, ()=>{
                this.addDelay(this.snakes.length * 100, ()=>
                {
                    if(gameData.curGameType == "COUNT") this.nextRound_Count();
                    else this.nextRoundRead_Listen();
                });
                while (this.snakes.length > 0) {
                    let snake = this.snakes.shift();
                    this.addDelay((this.snakes.length - 1) * 100, () => { snake.destroy(); });
                }

                this.buttonBlocker.disableInteractive();

                if(this.ui.numPad) this.ui.numPad.submitButton.setEnabled(true);
                else this.ui.snakeMenu.submitButton.setEnabled(true);
            });

            this.checkCurUnits();
            this.checkCorrectNum();
        }
        else
        {
            this.feedback.displayIncorrect();
        }
    }

    checkCurUnits()
    {
        let curCorrect = gameData.gameTypes[gameData.curGameType].curCorrect;
        let stagesComplete = gameData.gameTypes[gameData.curGameType].stagesComplete;

        if (gameData.units == 1) //We're in the ONES
        {
            this.curUnits = 1;
        }
        else if (gameData.units == 10) //We're in the TENS
        {
            this.curUnits = 10;
        }
        else //We're in the HUNDREDS
        {
            this.curUnits = 100;
        }
    }

    checkCorrectNum()
    {

        let curCorrect = gameData.gameTypes[gameData.curGameType].curCorrect;
        this.playUnlockedVO = false;

        if(curCorrect == 5)
        {

            curCorrect = 0;
            gameData.numUnlocked++;
            gameData.gameTypes[gameData.curGameType].stagesComplete++;

            if(!gameData.hasUnlocked)
            {
                gameData.hasUnlocked = true;
                this.playUnlockedVO = true;
            }

            this.addDelay(3000, ()=>{
                let correctSound = this.playSound(LocalizationSoundAssetKeys._five_correct_in_a_row, 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE);
                if (this.playUnlockedVO) {
                    this.addDelay(correctSound.duration * 1000, () => { this.playSound("change_your_snake_style", 1, false, false, Audio.LOCALIZATION_AUDIO_SPRITE); });
                }
                this.ui.menuButton.setEnabled(true);
                
                this.unlockedPopup.displayPopup();
            });
        }
        else
        {
            this.ui.menuButton.setEnabled(true);
        }

        gameData.gameTypes[gameData.curGameType].curCorrect = curCorrect;
        this.ui.correctCounter.text = curCorrect;

        this.ui.setAvailableUnits(this.curUnits);
    }

    removeSnake(snake)
    {
        this.snakes.splice(this.snakes.indexOf(snake), 1);
        this.ui.snakeMenu.refreshSnakeCount();
    }

    update()
    {
        this.feedback.update();
        for(let i = 0; i < this.snakes.length; i++)
        {
            this.snakes[i].update();
        }
    }
}